import { ScrollAdDispatcher } from "./ScrollAdDispatcher";
import { AdUnitsKeys } from "./config/units";
import React, { lazy, memo, Suspense } from "react";
import { useExperiments } from "hooks/useExperiments";
import { Loader } from "components/UI/Loader";

const StripChatAdDispatcher = lazy(() => import("./stripChat/StripChatAdDispatcher"));

interface IProps {
  position: number;
  fullscreen: boolean;
  mobileAds: AdUnitsKeys[];
  desktopAds: AdUnitsKeys[];
}

export const FeedAds = memo(({ position, fullscreen, mobileAds, desktopAds } : IProps) => {
  const { noAds = false } = useExperiments();

  if (noAds) {
    return null;
  }

  return !fullscreen ? (
    <ScrollAdDispatcher
      position={position + 1}
      mobileAds={mobileAds}
      desktopAds={desktopAds}
    />
  ) : (
    <Suspense fallback={<Loader />}>
      <StripChatAdDispatcher
        position={position}
      />
    </Suspense>
  );
});
